







































































import Vue from 'vue'

import Artifacts from '@/components/artifacts/Artifacts.tsx'
import Editor from '@/components/artifacts/NewEditor.tsx'

export default Vue.extend({
  components: { Artifacts, Editor },
  data() {
    return {
      then: '',
    }
  },
  props: {
    autosave: {
      default: false,
      type: Boolean,
    },
    sort: {
      type: [Object, Function, Array, String],
    },
    revert: {
      type: Boolean,
      default: false,
    },
    addAbove: {
      type: [Boolean, String],
      default: false,
      validator(value: boolean | string) {
        return typeof value === 'boolean' || value === 'if-empty'
      },
    },
    addBelow: {
      type: [Boolean, String],
      default: false,
      validator(value: boolean | string) {
        return typeof value === 'boolean' || value === 'if-empty'
      },
    },
    beforeSave: {
      type: Function,
      default() {
        return (entity: any) => ({ entity })
      },
    },
    defaults: {
      type: Object,
      default: () => ({}),
    },
    endpoint: {
      type: String,
      required: true,
    },
    tag: {
      type: String,
      default: 'div',
    },
    where: {
      type: [Object, Function, Array],
    },
  },
})
